// ---------------------------------------------------------------------------
// Curated state-park / preserve POLYGONS for deterministic "does this walk run
// THROUGH a park?" detection — no network, instant, unit-testable. Same pattern
// as the bundled US-states / nice-towns / great-drives data.
//
// Overpass `is_in` / polygon fetch proved unreliable in production (silently
// empty for big preserves), so we check these curated polygons FIRST and only
// fall back to a live Overpass search for parks not listed here. Grow this list
// the same way the curated drives grew — add { name, rings:[[ [lng,lat], … ] ] }.
//
// Rings are [lng, lat] (GeoJSON order). A simplified outer boundary is plenty —
// the containment test samples the route, so a ~10-vertex outline is enough to
// decide "the walk runs through this park."
// ---------------------------------------------------------------------------

import type { LngLat } from "@/utils/polyline";

export interface StateParkPolygon {
  name: string;
  /** One or more outer rings ([lng,lat] points). */
  rings: LngLat[][];
}

export const STATE_PARKS: StateParkPolygon[] = [
  {
    // Rockefeller State Park Preserve — Pocantico Hills, Westchester NY. The
    // main contiguous preserve around Swan Lake / Stone Barns; simplified outer
    // boundary. (Morgan's Stone Barns walk runs through its western side.)
    name: "Rockefeller State Park Preserve",
    rings: [[
      [-73.848, 41.095],
      [-73.846, 41.110],
      [-73.840, 41.122],
      [-73.828, 41.129],
      [-73.814, 41.126],
      [-73.807, 41.110],
      [-73.812, 41.099],
      [-73.825, 41.093],
      [-73.848, 41.095],
    ]],
  },
];
